// removed by extract-text-webpack-plugin
module.exports = {"buttonLink":"ActivitiesPage--buttonLink--3V_Yugry","button":"ActivitiesPage--button--2jSoZwwK","stateButton":"ActivitiesPage--stateButton--1dPiUvRm","bubble":"ActivitiesPage--bubble--284paPFs","eventName":"ActivitiesPage--eventName--2iT1xHnw","eventDate":"ActivitiesPage--eventDate--3i9ek9gl","locationSummary":"ActivitiesPage--locationSummary--1DWLfEti"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/ActivitiesPage/ActivitiesPage.css
// module id = 1180
// module chunks = 2